import { apiFetch } from "@/integrations/backend/client";

export interface ChatMessage {
  id: string;
  sender_id: string;
  profile_id: string;
  sender_name: string;
  sender_initials: string;
  sender_avatar_url: string | null;
  content: string;
  created_at: string | null;
  read_by_client_at: string | null;
  read_by_admin_at: string | null;
  is_sender: boolean;
}

export interface ChatConversation {
  user_id: string;
  user_name: string;
  user_avatar_url: string | null;
  user_initials: string;
  last_message: string;
  last_message_time: string | null;
  unread_count: number;
}

export interface SendMessageInput {
  profile_id: string;
  content: string;
}

/**
 * List all conversations for the current user (trainer/admin only).
 * @returns Array of conversations
 */
export async function listConversations(): Promise<ChatConversation[]> {
  const res = await apiFetch("/api/v1/chat/conversations", {
    method: "GET",
  });
  if (!res.ok) {
    throw new Error(`list_conversations_failed:${res.status}`);
  }
  return (await res.json()) as ChatConversation[];
}

/**
 * List messages between current user and another user.
 * @param otherUserId - UUID of the other user
 * @returns Array of messages
 */
export async function listMessages(otherUserId: string): Promise<ChatMessage[]> {
  const res = await apiFetch(`/api/v1/chat/messages/${encodeURIComponent(otherUserId)}`, {
    method: "GET",
  });
  if (!res.ok) {
    throw new Error(`list_messages_failed:${res.status}`);
  }
  return (await res.json()) as ChatMessage[];
}

/**
 * Send a message to another user.
 * @param input - Message data
 * @returns Created message
 */
export async function sendMessage(input: SendMessageInput): Promise<ChatMessage> {
  const res = await apiFetch("/api/v1/chat/messages", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!res.ok) {
    throw new Error(`send_message_failed:${res.status}`);
  }
  return (await res.json()) as ChatMessage;
}

